import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UPDATE_KILOMETER } from "../../constant-value";
import api from "../../services/axiosConfig";

// 🧠 Thunk برای بروزرسانی کیلومتر
export const updateCarKilometer = createAsyncThunk(
  "carKilometer/update",
  async ({ id, kilometer }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("kilometer", Number(kilometer));
      const res = await api.put(`${UPDATE_KILOMETER}/${id}`, formData);

      if (res.data.isSuccess) {
        return { id, kilometer, message: res.data.message };
      } else {
        return rejectWithValue(res.data.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const carKilometerSlice = createSlice({
  name: "carKilometer",
  initialState: {
    status: "idle",
    error: null,
    successMessage: null,
  },
  reducers: {
    clearCarKilometerState: (state) => {
      state.status = "idle";
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCarKilometer.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.successMessage = null;
      })
      .addCase(updateCarKilometer.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.successMessage = action.payload.message;
      })
      .addCase(updateCarKilometer.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "خطا در بروزرسانی کیلومتر";
      });
  },
});

export const { clearCarKilometerState } = carKilometerSlice.actions;
export default carKilometerSlice.reducer;
